import { render, staticRenderFns } from "./ModalVerDetalleCuadratura.vue?vue&type=template&id=315368b2&scoped=true&"
import script from "./ModalVerDetalleCuadratura.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDetalleCuadratura.vue?vue&type=script&lang=ts&"
import style0 from "./ModalVerDetalleCuadratura.vue?vue&type=style&index=0&id=315368b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315368b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('315368b2', component.options)
    } else {
      api.reload('315368b2', component.options)
    }
    module.hot.accept("./ModalVerDetalleCuadratura.vue?vue&type=template&id=315368b2&scoped=true&", function () {
      api.rerender('315368b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Cuadraturas/ModalVerDetalleCuadratura.vue"
export default component.exports